
import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TemplateService } from '../../services/template.service';
import { invoiceTemplateTesVars } from "./test-data/invoice-template.data"
import { receiptTemplateTesVars } from './test-data/receipt-template.data';
import { smsTemplateVars } from './test-data/sms-template.data';

@Component({
  selector: 'app-template-tests',
  templateUrl: './template-tests.component.html',
  styleUrls: ['./template-tests.component.scss']
})
export class TemplateTestsComponent implements OnInit {

  constructor(
    private templateService: TemplateService,
    public sanitizer: DomSanitizer) { }

  public template: string = "invoice.template.html";
  public renderedTemplate: string = "";

  public isHTML = true;

  ngOnInit(): void {

  }

  renderTemplate() {
    let vars: any;
    switch (this.template) {
      case "invoice.template.html":
        vars = invoiceTemplateTesVars;
        this.isHTML = true;
      break;
      case "receipt.template.html":
        vars = receiptTemplateTesVars;
        this.isHTML = true;
      break;
      case "sms-review-request.template.html":
        vars = smsTemplateVars;
        this.isHTML = false;
      break;
      case "sms-review-request-aged.template.html":
        vars = smsTemplateVars;
        this.isHTML = false;
      break;
      case "sms-repair-ready.template.html":
        vars = smsTemplateVars;
        this.isHTML = false;
      break;
    }

    console.log(vars)
    this.templateService.renderFile(this.template, vars).subscribe((reply: any) => {
        this.renderedTemplate = reply.render;
    });
  }
}
